import React from 'react'
import faro from './faro.png'
import { Box, Typography, Button } from '@mui/material'
import { MAIN } from '../../config/routes'
import { useNavigate, useLocation } from 'react-router-dom'
import { loadLastCityUrl } from '../../utils/lastCityStorage'
import WifiOffIcon from '@mui/icons-material/WifiOff'

//styles
import styles from './index.module.css'

const NotFoundPage = () => {
  const navigate = useNavigate()
  const location = useLocation()
  const errorType = location.state?.type || 'notFound'

  // Regresar a la última ciudad visitada; si no hay, al inicio.
  const goHome = () => navigate(loadLastCityUrl() || MAIN)

  const renderMessage = () => {
    switch (errorType) {
      case 'network':
        return (
          <>
            <WifiOffIcon sx={{ fontSize: 100 }} />
            <Typography variant="h2" color="primary" fontWeight="bold">
              Error de conexión
            </Typography>
            <Typography variant="h5" color="text.secondary" mb={4}>
              Parece que tienes problemas de red. Por favor, revisa tu conexión.
            </Typography>
          </>
        )
      case 'backend':
        return (
          <>
            <Typography variant="h2" color="primary" fontWeight="bold">
              Error del servidor
            </Typography>
            <Typography variant="h5" color="text.secondary" mb={4}>
              Lo sentimos, hubo un problema en nuestro sistema. Intenta más tarde.
            </Typography>
          </>
        )
      default:
        return (
          <>
            <Typography variant="h2" color="primary" fontWeight="bold">
              Error 404
            </Typography>
            <Typography variant="h5" color="text.secondary" mb={4}>
              Revisa si la dirección a la que quieres acceder es correcta.
            </Typography>
          </>
        )
    }
  }

  return (
    <Box
      sx={{
        height: '100vh',
        background: 'linear-gradient(to top, #cceeff, #ffffff)',
        overflow: 'hidden',
        position: 'relative',
        textAlign: 'center',
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center',
        px: 2,
      }}>
      <Box>
        <Typography variant="h2" color="text.primary" mb={4}>
          ¡Ups! No pudimos encontrar esta página.
        </Typography>
      </Box>
      <Box>
        <img className={styles.faro} src={faro} alt="faro" />
      </Box>

      {/* Mensaje dinámico */}
      <Box>{renderMessage()}</Box>

      <Box>
        <Button variant="contained" color="primary" onClick={goHome}>
          Ir al inicio
        </Button>
      </Box>
      {/* Nubes animadas */}
      <Box sx={{ position: 'relative', bottom: 0, right: 0, width: '100vw' }}>
        <Cloud delay="0s" />
        <Cloud delay="10s" />
        <Cloud delay="20s" />
      </Box>
    </Box>
  )
}

const Cloud = ({ delay }) => {
  return (
    <Box
      sx={{
        position: 'absolute',
        width: 200,
        height: 100,
        background: '#fff',
        borderRadius: '50%',
        boxShadow: '60px 0px 0px 0px #fff, 120px 10px 0px 0px #fff',
        opacity: 0.8,
        top: 0,
        left: '-250px',
        animation: `moveClouds 30s linear infinite`,
        animationDelay: delay,
      }}
    />
  )
}

export default NotFoundPage
